export const enum NotificationPosition {
    TOP = 'top-fix',
    BOTTOM = 'bottom-fix',
    LEFT = 'left-fix',
    RIGHT = 'right-fix'
}